import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import { Quotes } from '../../../../../containers/Blotters/Quotes';
import { QuotesV2 } from '../../../../../containers/Blotters/QuotesV2';
import { useFeatureFlag } from '../../../../../hooks';
import type { RFQsBlotterPanelConfig } from '../../../../../types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export const RFQsPanel = ({ params, api }: LayoutPanelProps<RFQsBlotterPanelConfig>) => {
  const { enableRFQBlotterV2 } = useFeatureFlag();
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.QuotesBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="rfqs-blotter-panel"
      >
        {enableRFQBlotterV2 ? <QuotesV2 /> : <Quotes />}
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
};
